<template>
  <div class="fixed bottom-5 right-5 z-[9999] flex flex-col gap-2.5 items-end pointer-events-none">
    <transition-group name="toast">
      <div
        v-for="toast in toasts"
        :key="toast.id"
        class="pointer-events-auto flex items-start gap-3 px-4 py-3 rounded-xl shadow-lg max-w-sm w-full text-sm font-medium leading-snug cursor-pointer select-none"
        :class="toastClass(toast.type)"
        @click="remove(toast.id)"
      >
        <!-- icon -->
        <span class="shrink-0 mt-0.5 text-base leading-none">
          <span v-if="toast.type === 'success'">✓</span>
          <span v-else-if="toast.type === 'error'">✕</span>
          <span v-else-if="toast.type === 'warn'">!</span>
          <span v-else>ℹ</span>
        </span>
        <span>{{ toast.message }}</span>
      </div>
    </transition-group>
  </div>
</template>

<script>
import { toastState, removeToast } from '@/plugins/toast.js';

export default {
  name: 'ToastContainer',
  computed: {
    toasts() {
      return toastState.toasts;
    },
  },
  methods: {
    remove(id) {
      removeToast(id);
    },
    toastClass(type) {
      return {
        success: 'bg-qorayGreen text-white',
        error:   'bg-red text-white',
        warn:    'bg-yellow text-black',
        info:    'bg-black text-white',
      }[type] || 'bg-black text-white';
    },
  },
};
</script>

<style scoped>
.toast-enter-active,
.toast-leave-active {
  transition: all 0.22s ease;
}
.toast-enter {
  opacity: 0;
  transform: translateY(12px) scale(0.96);
}
.toast-leave-to {
  opacity: 0;
  transform: translateX(20px);
}
</style>
